// Internal Module Imports
import { BASE_URL_BIDDING_SERVICE } from '../../../constants';
import { HttpClient } from '../../../utils/httpClient';

const PATH = {
    get: `/${BASE_URL_BIDDING_SERVICE}/root/economics`,
    getLedger: `/${BASE_URL_BIDDING_SERVICE}/root/economics/ledger`,
    getConsumption: `/${BASE_URL_BIDDING_SERVICE}/root/economics/consumption`,
    getEnergyRevenue: `/${BASE_URL_BIDDING_SERVICE}/root/economics/energy-revenue`,
    fixedChargers: `/root/economics/fixed-chargers`,
    scSavingLedgerData: `/root/economics/sc-saving-ledger`,
    scSavingOverviewData: `/${BASE_URL_BIDDING_SERVICE}/root/economics/sc-saving-overview`,
    esettSettlement: `/${BASE_URL_BIDDING_SERVICE}/root/economics/esett-settlement`,
};

const GetEconomics = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.get}`, { params }).then(callback).catch(error).finally(next);
};

const GetLedgerData = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.getLedger}`, { params }).then(callback).catch(error).finally(next);
};

const GetEnergyRevenue = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(PATH.getEnergyRevenue, { params }).then(callback).catch(error).finally(next);
};

const GetConsumption = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(PATH.getConsumption, { params }).then(callback).catch(error).finally(next);
};

const GetFixedChargersRevenue = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(PATH.fixedChargers, { params }).then(callback).catch(error).finally(next);
};

const GetSCSavingLedgerData = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(PATH.scSavingLedgerData, { params }).then(callback).catch(error).finally(next);
};

const GetSCSavingOverviewData = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(PATH.scSavingOverviewData, { params }).then(callback).catch(error).finally(next);
};

const GetEsettSettlement = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(PATH.esettSettlement, { params }).then(callback).catch(error).finally(next);
};

export const RootEconomicsService = {
    GetEconomics,
    GetLedgerData,
    GetConsumption,
    GetEnergyRevenue,
    GetFixedChargersRevenue,
    GetSCSavingLedgerData,
    GetSCSavingOverviewData,
    GetEsettSettlement,
};
